var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"brdr-none bg-cl-transparent p0 middle-xs inline-flex cl-secondary",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"icon-close h5 cl-black weight-900"})])}
var staticRenderFns = []

export { render, staticRenderFns }